angular.module('cn')
.service('accountsRepository', [
  '$http',
  '$q',
  '$rootScope',
  'ENV',
  'promiseCache',
  function(
    $http,
    $q,
    $rootScope,
    ENV,
    promiseCache
  ) {

    var accountsCache = promiseCache.create(function() {
      return $http({
        method: 'GET',
        url: `${ENV.EIAM_URL}/customeraccounts`
      }).then(function(raw) {
        if (!raw.data.data.customer_accounts) {
          return [];
        }
        return raw.data.data.customer_accounts.map(function(item) {
          return {
            name: item.name,
            id: item.id
          };
        });
      }).catch(function(err) {
        $rootScope.$emit('onBackendError', 'Can not get customer accounts data');
        return $q.reject(err);
      });
    });

    this.getAll = function() {
      return accountsCache.get();
    };

  }
]);



// WEBPACK FOOTER //
// ./src/cn/services/accountsRepository.js